import { Colors } from '@guildeducationinc/recess';
import Particles, { IParticlesProps } from 'react-particles';
import type { Engine, ISourceOptions } from 'tsparticles-engine';
import { loadConfettiPreset } from 'tsparticles-preset-confetti';
import { useIsMobile } from '@src/utilities/screenResizeUtility';

export const Confetti: React.FC<IParticlesProps> = () => {
  // this customizes the component tsParticles installation
  async function customInit(engine: Engine): Promise<void> {
    // this adds the preset to tsParticles, you can safely use the
    await loadConfettiPreset(engine);
  }

  const isMobile = useIsMobile();
  const DESKTOP_X_POSITIONS = [10, 30, 50, 70, 90];
  const DESKTOP_QUANTITY = 20;
  const DESKTOP_SPEED_RANGE = { min: 50, max: 70 };

  const MOBILE_X_POSITIONS = [30, 70];
  const MOBILE_SPEED_RANGE = { min: 30, max: 50 };
  const MOBILE_QUANTITY = 15;

  const velvetColors = [
    Colors.GraphicBackground1,
    Colors.GraphicBackground3,
    Colors.GraphicBackground4,
    Colors.GraphicBackground5,
    Colors.GraphicBackground6,
  ];
  const screenTopEmitter = (xPosition: Number, quantity: Number) => ({
    life: {
      duration: 0.5,
      count: 2,
    },
    position: {
      x: xPosition,
      y: 0,
    },
    rate: {
      quantity,
      delay: 0.1,
    },
  });

  const options = (isMobile: boolean): ISourceOptions => {
    const emitters = isMobile
      ? MOBILE_X_POSITIONS.map((position) => screenTopEmitter(position, MOBILE_QUANTITY))
      : DESKTOP_X_POSITIONS.map((position) => screenTopEmitter(position, DESKTOP_QUANTITY));
    const speed = isMobile ? MOBILE_SPEED_RANGE : DESKTOP_SPEED_RANGE;
    return {
      particles: {
        color: {
          value: velvetColors,
        },
        move: {
          direction: 'none',
          speed,
        },
      },
      emitters,
      preset: 'confetti',
    };
  };

  return <Particles options={options(isMobile)} init={customInit} />;
};
